import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';

export interface UccpConfiguration {
  paymentUrl: string;
  account: string;
}

@Injectable({
  providedIn: 'root'
})
export class UccpService {

  constructor(private http: HttpClient) {
  }

  fetchUccpConfig(cartId: number): Observable<UccpConfiguration> {
    return this.http.get<UccpConfiguration>(`/api/uccp-configuration/${cartId}`);
  }

}
